import { default as NextImage, ImageProps } from 'next/image';
import React, { useRef, useState } from 'react';
import classes from './classes.module.css';
import cls from 'classnames';

type Props = ImageProps & {
  shimmer?: {
    borderRadius: number | string;
  };
  useNativeImg?: boolean;
};

export default function ShimmerImage({ ...props }: Props) {
  const [isLoading, setIsLoading] = useState(true);

  function handleLoadImage() {
    setIsLoading(false);
  }

  return (
    <div
      className={cls(classes.container, isLoading && classes.shimmer)}
      style={{
        borderRadius: props.shimmer?.borderRadius ?? 0,
        width: props.width ?? '100%',
        height: props.height ?? '100%',
      }}
    >
      {props.useNativeImg ? (
        <img
          src={props.src.toString()}
          onLoad={handleLoadImage}
          onError={handleLoadImage}
          width={props.width}
          height={props.height}
          style={{ objectFit: props.objectFit }}
          className={props.className}
        />
      ) : (
        <NextImage
          {...props}
          onLoad={handleLoadImage}
          onError={handleLoadImage}
          className={cls(props.className, isLoading && classes.hidden)}
        />
      )}
    </div>
  );
}

function isCachedImage(src: string) {
  const image = new Image();
  image.src = src;
  return image.complete;
}
